const KEY = 'carrerup:billing-intent';
export function rememberPlan(plan) {
  try {
  if (plan === 'monthly' || plan === 'yearly') localStorage.setItem(KEY, JSON.stringify({ plan, expires: Date.now() + 7 * 86400000 }));
  else localStorage.removeItem(KEY);
  } catch { /* Storage may be disabled by browser privacy settings. */ }
}
export function pendingPlan() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY));
    return value?.expires > Date.now() && ['monthly', 'yearly'].includes(value.plan) ? value.plan : null;
  } catch { return null; }
}
export function afterLogin() { return pendingPlan() ? '/billing' : '/home'; }
